import { MODAL_ID_DEFAULT } from '../../../constants/common'
import { MINIMIZED_MODAL_KEY } from '../../Modal'

export const LAYOUT_HEADER_EMAIL_DRAFT_PREFIX = 'layout-header-emails'

export const LAYOUT_HEADER_REQUEST_DRAFT_PREFIX = 'layout-header-request'

export const LAYOUT_HEADER_REQUEST_WIZARD_DRAFT_PREFIX =
  'layout-header-request-wizard'

export const LAYOUT_HEADER_MODALS_CONFIG = {
  setEmailFormModal: {
    closer: 'closeEmailFormModal',
    id: MINIMIZED_MODAL_KEY.EMAIL_FORM,
  },
  setModal: { closer: 'closeModal', id: MODAL_ID_DEFAULT },
  setRequestFormModal: {
    closer: 'closeRequestFormModal',
    id: MINIMIZED_MODAL_KEY.REQUEST_FORM,
  },
}
